import React from 'react';
import { Fab, CircularProgress } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const UploadFab = ({ isMobile, isSplitting, handleUpload, isUploading }) => {
  if (!isMobile || isSplitting) {
    return null;
  }

  return !isUploading && (
    <Fab
      color="primary"
      aria-label="upload"
      onClick={handleUpload}
      disabled={isUploading}
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: 40,
      }}
    > <AddIcon /> </Fab>
  );
};

export default UploadFab;
